import React, { MouseEvent } from 'react';
import styled from 'styled-components';
import {TAppElkInvitee} from "TProtocol/prototypes/events/messages";

interface Props {
  cancelledDateString?: (string);
}

const EventCancelledIndicator = ({cancelledDateString}: Props) => {
  return <Container>
    {'This event has been cancelled by the host ' +  cancelledDateString }
  </Container>;
};

const Container = styled.div`
  font-family: Roboto-Bold, sans-serif;
  background-color: black;
  color: white;
  border-radius: 12px;
  padding: 6.66666666667px 66.3333333333px 6.66666666667px 66.3333333333px;
  margin-top: 40px;
  cursor: pointer;
  font-size: 12pt;
  display: flex;
  flex-direction: column;
  line-height: 24px;
  text-align: center;
  
  &:hover {
    filter: brightness(90%);
  }
`;

export default EventCancelledIndicator;
